import React from "react";
import { Plan } from "../../../@types";
import { CurrentPlan } from "./CurrentPlan";
import { PlanInfo } from "./PlanInfo";
import { PlanContact } from "./PlanContact";

export const PlanHeader: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  return (
    <div>
      <CurrentPlan plan={plan} />
      <PlanInfo plan={plan} />
      <PlanContact plan={plan} />
    </div>
  );
};
